"use client"

import { SourceOptionDropdowns } from "@/components/source-option-dropdowns"
import { XVIDEOS_CATEGORIES } from "@/lib/xvideos-categories"
import { useTranslations } from "next-intl"

const ORDERS = ["relevance", "newest", "most-viewed", "today", "week", "month"] as const
const ORIENTATIONS = ["straight", "gay", "trans"] as const

interface XvideosFilterTabsProps {
  order: string
  orientation: string
  category: string
  onCategoryChange: (value: string) => void
  onOrderChange: (value: string) => void
  onOrientationChange: (value: string) => void
}

// XVideos' sort, date window and orientation (the site's own sort=, datef= and typef= options), see lib/booru-sources/booru-api/xvideos.ts.
export function XvideosFilterTabs({ order, orientation, category, onCategoryChange, onOrderChange, onOrientationChange }: XvideosFilterTabsProps) {
  const t = useTranslations("xvideosFilterTabs")
  return (
    <SourceOptionDropdowns
      groups={[
        { id: "category", label: t("category"), value: category, defaultValue: "all", options: [{ value: "all", label: t("allCategories") }, ...XVIDEOS_CATEGORIES.map((c) => ({ value: c.slug, label: c.label }))] },
        { id: "order", label: t("order"), value: order, defaultValue: "relevance", options: ORDERS.map((value) => ({ value, label: t(value) })) },
        { id: "orientation", label: t("orientation"), value: orientation, defaultValue: "straight", options: ORIENTATIONS.map((value) => ({ value, label: t(value) })) },
      ]}
      onChange={(id, value) => (id === "category" ? onCategoryChange(value) : id === "order" ? onOrderChange(value) : onOrientationChange(value))}
    />
  )
}
